<template>
    <div>
        <el-dialog :title="'设备选择'" :visible.sync="visible" @close="close" width="70%">
            <el-row>
                <el-row>
                    <el-table :data="page.records" @selection-change="handleSelectionChange">
                        <el-table-column
                                type="selection"
                                width="55">
                        </el-table-column>
                        <el-table-column prop="code" label="编号">
                            <template slot="header" slot-scope="scope">
                                <span v-if="scope != null">编号</span><br>
                                <el-input size="mini" v-model="pageSearch.search.code">
                                </el-input>
                            </template>
                            <template slot-scope="scope">
                                <el-button @click="toDetailShow(scope.row)" type="text" size="mini">
                                    {{scope.row.code}}
                                </el-button>
                            </template>
                        </el-table-column>
                        <el-table-column label="数据中心">
                            <template slot="header" slot-scope="scope">
                                <span v-if="scope != null">数据中心</span><br>
                                <dictionary-select v-model="pageSearch.search.roomId"
                                                   :factory-name="'room'" :params="{type: 'AUTH_SITE'}"
                                                   :clearable="true" :filterable="true" size="mini">
                                </dictionary-select>
                            </template>
                            <template slot-scope="scope">
                                <dictionary-text :factory-name="'room'" :params="{type: 'AUTH_SITE'}" :value="scope.row.roomId">
                                </dictionary-text>
                            </template>
                        </el-table-column>
                        <el-table-column prop="type" label="类型">
                            <template slot="header" slot-scope="scope">
                                <span v-if="scope != null">类型</span><br>
                                <dictionary-select v-model="pageSearch.search.type"
                                                   :factory-name="'domain'" :params="'ASSETTYPE'"
                                                   :clearable="true" :filterable="true" size="mini">
                                </dictionary-select>
                            </template>
                            <template slot-scope="scope">
                                <dictionary-text :factory-name="'domain'" :params="'ASSETTYPE'" :value="scope.row.type">
                                </dictionary-text>
                            </template>
                        </el-table-column>
                        <!--<el-table-column label="供应商">
                            <template slot="header" slot-scope="scope">
                                <span v-if="scope != null">供应商</span><br>
                            </template>
                            <template slot-scope="scope">
                                {{scope.row.vendorId}}
                            </template>
                        </el-table-column>-->
                        <el-table-column prop="description" label="描述">
                            <template slot="header" slot-scope="scope">
                                <span v-if="scope != null">描述</span><br>
                                <el-input size="mini" class="width70"
                                          v-model="pageSearch.search.description">
                                </el-input>
                            </template>
                        </el-table-column>

                        <el-table-column label="位置">
                            <template slot="header" slot-scope="scope">
                                <span v-if="scope != null">位置</span><br>
                                <location-select ref="locationSelect" v-model="pageSearch.search.locationId" :room-id="pageSearch.search.roomId"
                                                 :clearable="true" :filterable="true"
                                                 :size="'mini'" :clazz="{'width100': true}">
                                </location-select>
                            </template>
                            <template slot-scope="scope">
                                {{$refs.locationSelect.getLabelByValue(scope.row.locationId, $refs.locationSelect.locations)}}
                            </template>
                        </el-table-column>
                    </el-table>
                </el-row>
                <el-row type="flex" class="row-bg" justify="end">
                    <el-pagination
                            @current-change="setPageSearchCurrent"
                            @size-change="setPageSearchSize"
                            :current-page="pageSearch.current"
                            :page-sizes="[10, 25, 50, 100]"
                            :page-size="pageSearch.size"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="page.total">
                    </el-pagination>
                </el-row>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button @click="close">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import DcimServer from "@/api/dcim";
    import DictionarySelect from "@/components/common/DictionarySelect";
    import DictionaryText from "@/components/common/DictionaryText";
    import LocationSelect from "@/components/location/location-select";
    import {RESOURCE_IP_PORT} from "@/api";

    export default {
        name: "equipment-page-select-dialog",
        components: {
            LocationSelect,
            DictionarySelect, DictionaryText,
        },
        data() {
            return {
                selectedRows: [],
                pageSearch: {
                    current: 0,
                    size: 10,
                    search: {
                        code: null,
                        type: null,
                        description: null,
                        locationId: null,
                    },
                },
                page: {
                    total: 0,
                    records: [],
                },

                visible: false,
            };
        },
        watch: {
            'pageSearch.current': {
                deep: false,
                immediate: false,
                handler() {
                    this.queryByPage();
                },
            },
            'pageSearch.size': {
                deep: false,
                immediate: false,
                handler() {
                    this.reQueryByPage();
                },
            },
            'pageSearch.search': {
                deep: true,
                immediate: false,
                handler(search) {
                    this.reQueryByPage();
                    if (search != null) {
                        //
                    }
                }
            },
        },
        methods: {
            setPageSearchCurrent(current) {
                this.pageSearch.current = current;
            },
            setPageSearchSize(size) {
                this.pageSearch.size = size;
            },
            setPage(page) {
                this.page = page;
            },
            async doQueryByPage(pageSearch) {
                return DcimServer.equipment.page(pageSearch);
            },
            reQueryByPage() {
                if (this.pageSearch.current === 1) {
                    this.queryByPage();
                } else {
                    this.setPageSearchCurrent(1);
                }
            },
            async queryByPage() {
                let page = {total: 0, records: [],};
                let pageSearch = JSON.parse(JSON.stringify(this.pageSearch));
                page = await this.doQueryByPage(pageSearch);
                if (page.records.length === 0 && pageSearch.current > 1) {
                    this.setPageSearchCurrent(pageSearch.current - 1);
                } else {
                    this.setPage(page);
                }
                return Promise.resolve(page);
            },
            query() {
                this.queryByPage();
            },
            reQuery() {
                this.reQueryByPage();
            },
            toDetailShow(row) {
                window.open(`${process.env.VUE_APP_WEB_API}/dcim/equipment?id=${row.id}`);
            },
            handleSelectionChange(val) {
                this.selectedRows = val;
            },

            open() {
                this.visible = true;
                this.reQuery();
            },
            close() {
                this.visible = false;
            },
            confirm() {
                let selectedRows = this.selectedRows;
                if (selectedRows == null || selectedRows.length <= 0) {
                    this.$message.error('请选择设备！');
                } else {
                    this.$emit('confirm', selectedRows);
                }
            },
        },
    }
</script>

<style scoped>

</style>
